import { Approver } from "models/IApprover";
import { sponsorAxiosInstance } from "./base-service";


export const GetUserDetails = (): Promise<any> => {
    return sponsorAxiosInstance.get('benefit/users/v1');
}

export const GetSponsorDetails = (sponsorId: number): Promise<any> => {
    return sponsorAxiosInstance.get(`v1/Sponsor/${sponsorId}`);
}

export const GetApproversList = (): Approver[] | undefined => {
    if (sessionStorage.getItem('approvers') != null)
        return JSON.parse(sessionStorage.getItem('approvers') ?? '[]') as Approver[];
    sponsorAxiosInstance.get('/v1/User/AlternateApprovers').then((response) => {
        sessionStorage.setItem('approvers', JSON.stringify(response.data));
        return response.data as Approver[];
    }).catch((error) => {
        return undefined;
    });
}

export const GetManager = (): Approver | undefined => {
    if (sessionStorage.getItem('manager') != null)
        return JSON.parse(sessionStorage.getItem('manager') ?? '{}') as Approver;
    sponsorAxiosInstance.get('/v1/User/Manager').then((response) => {
        sessionStorage.setItem('manager', JSON.stringify(response.data));
        return response.data as Approver;
    }).catch((error) => {
        return undefined;
    });
}